import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PointAdminState } from 'src/app/core/store/admin/point/pointAdmin.reducer';

export const selectPointAdminState = createFeatureSelector<PointAdminState>('pointsAdmin');

export const selectPointState = createSelector(
    selectPointAdminState,
    (state: PointAdminState) => state.points
);

export const selectAllPoints = createSelector(
    selectPointAdminState,
    (state) => state.points
);

export const selectPointsLoading = createSelector(
    selectPointAdminState,
    (state) => state.loading
);

export const selectPointsError = createSelector(
    selectPointAdminState,
    (state) => state.error
);

export const selectSelectedPoint = createSelector(
    selectPointAdminState,
    (state) => state.selectedPoint
);